import { Panel, StatelessAccordion } from 'baseui/accordion'
import { CustomToggleIcon } from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import { StyledLi, StyledText } from './styled-components'
import { useState } from 'react'

const MeterInformationAccordion = ({ mainPanels, otherPanels }) => {
  const [expanded, setExpanded] = useState(['basic0'])
  const separator = <p>:</p>

  return (
    <StatelessAccordion
      expanded={expanded}
      onChange={({ expanded }) => {
        setExpanded(expanded)
      }}
      overrides={{
        Root: {
          style: () => ({
            borderRadius: '.5rem',
            borderRight: '1px solid #D6D7D8',
            borderLeft: '1px solid #D6D7D8',
            borderTop: '1px solid #D6D7D8',
          }),
        },
        Content: {
          style: () => ({
            background: '#EDEEEE',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            color: '#58595B',
            ':first-child': {
              borderTop: '1px solid #D6D7D8',
            },
          }),
        },
        PanelContainer: {
          style: () => ({
            borderRadius: 'none',
            borderBottom: '1px solid #D6D7D8',
            ':last-child': {
              borderRadius: '0 0 .5rem 0.5rem',
              borderBottom: '1px solid #D6D7D8',
            },
          }),
        },
        Header: {
          style: () => ({
            borderRadius: '.5rem',
            color: '#343535',
            fontWeight: 600,
            letterSpacing: '-0.008px',
            fontSize: '.875rem',
            lineHeight: '160%',
            paddingTop: '.5rem',
            paddingBottom: '.5rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            ':hover': {
              color: 'black',
            },
          }),
        },
        ToggleIcon: {
          component: CustomToggleIcon,
        },
      }}
    >
      {mainPanels?.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'basic' + indexPanel}>
            <>
              {content.text.map((content, index) => {
                return (
                  <StyledLi key={'p_basic' + index}>
                    {content?.text} {content?.text ? separator : ''} <StyledText>{content?.value}</StyledText>
                  </StyledLi>
                )
              })}
            </>
          </Panel>
        )
      })}
      {otherPanels?.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'details' + indexPanel}>
            <>
              {content.text.map((content, index) => {
                return (
                  <StyledLi key={'p_panels' + index}>
                    {content?.text} <StyledText>{content?.value}</StyledText>
                  </StyledLi>
                )
              })}
            </>
          </Panel>
        )
      })}
    </StatelessAccordion>
  )
}

export default MeterInformationAccordion
